import { useEffect, useState, useCallback, useMemo } from 'react';
import { prop, path } from 'js/utils/ramda.util';
import { useUserSelector, useAppSelector } from 'js/store/hooks';

import placeholderImage from '../images/game_placeholder.svg';

export const useGameImageUrl = ({ code, dynamicImageUrl, isLiveGame }) => {
    const images = useAppSelector(path(['games', code, 'images']));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const cmsImageUrl = !isLoggedIn && images.guest || images.base;
    const [imageUrl, setImageUrl] = useState(isLiveGame && dynamicImageUrl ? dynamicImageUrl : cmsImageUrl);

    const onError = useCallback(() => {
        if (imageUrl !== cmsImageUrl && imageUrl !== placeholderImage) {
            setImageUrl(cmsImageUrl);

            return;
        }

        setImageUrl(placeholderImage);
    }, [imageUrl, cmsImageUrl, setImageUrl]);

    useEffect(() => {
        if (!isLiveGame) {
            setImageUrl(cmsImageUrl);

            return;
        }

        const image = document.createElement('img');

        image.onload = () => setImageUrl(dynamicImageUrl);
        image.onerror = () => setImageUrl(cmsImageUrl);

        image.src = dynamicImageUrl;
    }, [dynamicImageUrl, cmsImageUrl, isLiveGame]);

    return useMemo(() => ({ imageUrl, onError }), [imageUrl, onError]);
};
